import { BreadCrumbDataProvider } from 'app/crumbs/context/breadCrumbData'
import React, { useState } from 'react'

interface BreadCrumbData {
  tenderCode: string
  appointmentProposalEasyID: string
  workstationName: string
  clockingItemName: string
}

export type BreadCrumbState = Partial<BreadCrumbData>

export const BreadCrumbDataProviderContainer: React.FC = ({ children }) => {
  const [breadCrumbData, setBreadCrumbData] = useState<BreadCrumbState>({})

  return <BreadCrumbDataProvider value={{ breadCrumbData, setBreadCrumbData }}>{children}</BreadCrumbDataProvider>
}

BreadCrumbDataProviderContainer.displayName = 'BreadCrumbDataProviderContainer'

export default BreadCrumbDataProviderContainer
